import { createApp } from 'vue'

// Suppress harmless ResizeObserver loop error
const resizeObserverErr = 'ResizeObserver loop completed with undelivered notifications.'
window.addEventListener('error', (e) => {
  if (e.message === resizeObserverErr) {
    e.stopImmediatePropagation()
    e.preventDefault()
  }
})
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason?.message === resizeObserverErr) {
    e.preventDefault()
  }
})

import App from './App.vue'
import router from "./router";
import vClickOutside from "click-outside-vue3";
import { registerScrollSpy } from 'vue3-scroll-spy';

import { vMaska } from "maska"
import i18n from "./i18n"

import { BootstrapVueNext } from 'bootstrap-vue-next';
import Toast from "vue-toastification";

import "vue-toastification/dist/index.css";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import "@/assets/scss/app.scss";
import "@vueform/multiselect/themes/default.css"

import pinia from '@/state/pinia'

import 'sweetalert2/dist/sweetalert2.min.css';
import '@vueform/slider/themes/default.css';
import '@fortawesome/fontawesome-free/css/all.css';
import 'boxicons/css/boxicons.min.css';

import { useLocaleStore } from '@/state/pinia/locale'

const toastOptions = {
  position: "bottom-right",
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false
}

const app = createApp(App)

app.config.errorHandler = (err) => {
  if (err?.message === resizeObserverErr) return
  throw err
}

app
  .use(pinia)
  .use(router)
  .use(BootstrapVueNext)
  .use(vClickOutside)
  .use(i18n)
  .use(Toast, toastOptions)
  .use(registerScrollSpy)
  .directive("maska", vMaska)
  .mount('#app')

useLocaleStore().init();

import { useAuthStore } from '@/state/pinia';

const authStore = useAuthStore();
authStore.checkSession();
// Live-refresh user (workspaces synced from SSO) on every app load, so
// workspaces added in SSO appear without a fresh login.
authStore.refreshMe();